import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/motorista-pendencia-motivo',
  name: 'motorista-pendencia-motivo',
  component: Index,
  children: [
    { path: 'listar', name: 'motorista-pendencia-motivo-listar', component: Listar },
    { path: 'novo', name: 'motorista-pendencia-motivo-novo', component: Novo },
    { path: ':id', name: 'motorista-pendencia-motivo-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'motorista-pendencia-motivo-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/motorista-pendencia-motivo/routes.js